import { OnInit, ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';
import { UsersService } from '../../../shared/services/users.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { LocalisationService } from '../../../shared/services/localisation.service';
import { MinutesToReadableTimePipe } from '../../../shared/pipes/minutesToReadableTime.pipe';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { MasterService, MealOverwriteViewModel } from '../../../shared/services/master.service';
var MasterMealOverwriteSectionComponent = /** @class */ (function () {
    function MasterMealOverwriteSectionComponent(usersService, changeDetectorRef, notificationService, localisationService, minutesToReadableTimePipe, appLoadingEventsEmitter, masterService) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.notificationService = notificationService;
        this.localisationService = localisationService;
        this.minutesToReadableTimePipe = minutesToReadableTimePipe;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.masterService = masterService;
    }
    MasterMealOverwriteSectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        forkJoin(this.masterService.getMealOverwrites(this.id), this.masterService.getMealsWithDailyMeals(this.id))
            .subscribe(function (_a) {
            var meal_overwrites = _a[0], meals_with_daily_meal = _a[1];
            _this.meal_overwrites = meal_overwrites;
            _this.meals_with_daily_meal = meals_with_daily_meal;
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.markForCheck();
        });
    };
    MasterMealOverwriteSectionComponent.prototype.updateProfile = function () {
        var _this = this;
        var mealsOverwritesPassed = true;
        this.meal_overwrites.map(function (meal) {
            if (!meal.meal
                || !meal.percentage
                || (meal.percentage < 0 || meal.percentage > 100)) {
                mealsOverwritesPassed = false;
            }
        });
        if (!mealsOverwritesPassed) {
            this.notificationService.error(this.localisationService.localise('enter_all_fields'));
            return;
        }
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.masterService.updateMealsWithDailyMeals(this.id, this.meal_overwrites).subscribe(function (update) {
            _this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            _this.changeDetectorRef.markForCheck();
            _this.notificationService.success(_this.localisationService.localise('settings_profile_updated_successfully'));
        });
    };
    MasterMealOverwriteSectionComponent.prototype.addTraining = function () {
        this.meal_overwrites.push(new MealOverwriteViewModel());
        this.changeDetectorRef.markForCheck();
    };
    MasterMealOverwriteSectionComponent.prototype.removeTraining = function (index) {
        this.meal_overwrites.splice(index, 1);
        this.changeDetectorRef.markForCheck();
    };
    MasterMealOverwriteSectionComponent.prototype.duplicateTraining = function (index) {
        var new_meal = new MealOverwriteViewModel();
        new_meal.percentage = this.meal_overwrites[index].percentage;
        new_meal.meal = this.meal_overwrites[index].meal;
        this.meal_overwrites.push(new_meal);
        this.changeDetectorRef.markForCheck();
    };
    MasterMealOverwriteSectionComponent.prototype.onMealChange = function (event, index) {
        // tslint:disable-next-line:radix
        this.meal_overwrites[index].meal = this.meals_with_daily_meal.find(function (m) { return m.id === parseInt(event.target.value); });
        this.changeDetectorRef.markForCheck();
    };
    MasterMealOverwriteSectionComponent.prototype.onPercentageChange = function (event, index) {
        // tslint:disable-next-line:radix
        this.meal_overwrites[index].percentage = parseInt(event.target.value);
        this.changeDetectorRef.markForCheck();
    };
    MasterMealOverwriteSectionComponent.prototype.convertToTrainingsDTO = function () {
        var dtoData = [];
        // this.trainings.map(training => {
        //     dtoData.push({
        //         'day': training.day,
        //         'training_activity_id': training.training_activity.id,
        //         'training_duration_id': training.training_duration.id,
        //     });
        // });
        return dtoData;
    };
    return MasterMealOverwriteSectionComponent;
}());
export { MasterMealOverwriteSectionComponent };
